var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.03,
    height: 6.03,
    viewBox: "0 0 6.03 6.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e56868;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M392.173,178.449l-1.592-1.592,1.592-1.591a.834.834,0,1,0-1.179-1.179l-1.591,1.592-1.592-1.592a.834.834,0,1,0-1.179,1.179l1.592,1.591-1.592,1.592a.834.834,0,1,0,1.179,1.179l1.592-1.592,1.591,1.592a.834.834,0,1,0,1.179-1.179Z",
    transform: "translate(-386.387 -173.843)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.490a6b6f7f220d343ce3edb48bd49fef.svg";
export { ForwardRef as ReactComponent };